var _linearGradient, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Screwdriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "JjHkuvLzdQ6PEVWp6tlU4a",
    x1: 20.414,
    x2: 26.414,
    y1: 10.086,
    y2: 10.086,
    gradientTransform: "rotate(45.001 22 24.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#JjHkuvLzdQ6PEVWp6tlU4a)",
    points: "44.153,7.176 41.324,4.347 37.081,7.176 34.253,11.419 22.232,23.439 25.061,26.268 37.081,14.247 41.324,11.419"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#af2031",
    d: "M22.232,31.925c1.339-1.339,2.771-2.362,4.08-2.991l-6.746-6.746 c-0.629,1.309-1.652,2.741-2.991,4.08c-0.996,0.996-2.044,1.818-3.054,2.432c-1.251,0.761-2.43,1.637-3.466,2.673 c-2.59,2.59-4.744,4.744-4.894,4.894c-1.897,1.897-1.853,5.019,0.099,6.972c1.952,1.952,5.074,1.997,6.972,0.099l4.898-4.898 c0.96-0.96,1.831-2.012,2.507-3.189C20.267,34.158,21.146,33.01,22.232,31.925z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c94f60",
    d: "M25.414,29.45l-6.364-6.364c-0.586-0.586-0.586-1.536,0-2.121l0,0c0.586-0.586,1.536-0.586,2.121,0 l6.364,6.364c0.586,0.586,0.586,1.536,0,2.121l0,0C26.95,30.036,26,30.036,25.414,29.45z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Screwdriver);
export default __webpack_public_path__ + "static/media/icons8-screwdriver.d6ff8977e613f841b8f7fcbf6eb7e9a4.svg";
export { ForwardRef as ReactComponent };